import { isIos } from '../../../../../utils';
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isCar: {
      type: Boolean,
      default: false
    },
    isHouse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    poiFontWeight() {
      if (isIos()) {
        return {
          fontWeight: '500'
        };
      }
      return {
        fontWeight: '700'
      };
    }
  },
  methods: {
    goPurchase(url) {
      this.$emit('goPurchase', url);
    }
  }
};